import { action } from 'typesafe-actions';
import { IActionTypesColetaNoCd, IColetaNoCd, IFilter, IPaginationColetaNoCd } from './types';

export const loadRequest = (
  filtro: IFilter | undefined,
  parceiros: number[],
  codCdd: number,
  pagination?: IPaginationColetaNoCd,
  sorter?: any
) =>
  action(IActionTypesColetaNoCd.LOAD_REQUEST, {
    filtro,
    parceiros,
    codCdd,
    pagination,
    sorter,
  });
export const loadSuccess = (data: IColetaNoCd[], pagination: IPaginationColetaNoCd) =>
  action(IActionTypesColetaNoCd.LOAD_SUCCESS, { data, pagination });

export const loadFailure = () => action(IActionTypesColetaNoCd.LOAD_FAILURE);

export const filterColetaCD = (filter: IFilter) =>
  action(IActionTypesColetaNoCd.FILTER_COLETACD, { filter });

export const sorterColetaCD = (ordenacao: any) =>
  action(IActionTypesColetaNoCd.SORTER_COLETACD, { ordenacao });

export const cleanStateColetaNoCd = () => action(IActionTypesColetaNoCd.CLEAN_COLETANOCD);
